import configure, {type SettingsOptions, type SettingsPreferences} from "@pata/settings";
import * as settings from "@pata/settings";
import navConfig from "./navigation";
import presetConfig from './presets'

configure({
    navigation: navConfig,
    name: "PATA",
    domain: "pata.lv",
    email: "olegs.sasko@pata.lv",
    presets: presetConfig,
    localization: {
        locales: ['lv', 'en', 'cn', 'lt'],
        default: 'lv'
    }
})

export const preferences: Readonly<SettingsPreferences> = settings.preferences()
export const options: Readonly<SettingsOptions> = settings.options()